import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { LocalStorageService } from '@app/services/local-storage.service';

@Component({
  selector: 'app-dashboard-layout',
  imports: [CommonModule, RouterOutlet, RouterModule],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
})
export class DashboardLayoutComponent {
  consigneeName = '';
  isMobileView: boolean = window.innerWidth < 768;
  authService = inject(AuthService);
  localStorageService = inject(LocalStorageService);
  router = inject(Router);

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = window.innerWidth < 768;
  }

  constructor() {
    const jwt = this.authService.getUserFromJwt();
    this.consigneeName = jwt.unique_name;
  }

  logout(): void {
    this.localStorageService.clearStorage();
    this.router.navigate(['/auth']);
  }

  openProfile(): void {
    this.router.navigate(['/profile']);
  }

  getYear() {
    return new Date().getFullYear();
  }
}
